import styled from "styled-components";

export const StyledForm = styled.form`
  width: 34rem;
  display: flex;
  flex-direction: column;
`;

export const StyledModalHeader = styled.div`
  margin: auto;
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 2rem 0;
  height: 100%;
  width: 100%;
  row-gap: 1rem;
`;

export const StyledFormRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledRightColumn = styled.div`
  display: flex;
  align-items: center;
  width: 21.5rem;
  column-gap: 1rem;
`;

export const StyledInputWithSelect = styled.div`
  display: flex;
  column-gap: 0.2rem;
`;

export const StyledModalFooter = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
`;
export const StyledButtonArea = styled.div`
  display: flex;
  justify-content: center;

  gap: 1rem;
`;
